import { render, staticRenderFns } from "./EvalUserRequestsDialog.vue?vue&type=template&id=c67f9a5a"
import script from "./EvalUserRequestsDialog.vue?vue&type=script&lang=js"
export * from "./EvalUserRequestsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports